import { fetchJson } from '~/lib/fetch';
import type { DiscussionSort, DiscussionFilter } from './types';

/**
 * Construct the URL for fetching comments from the discussions API.
 */
export function getDiscussionsUrl({
  dealId,
  type,
  page = 1,
  sort = 'latest',
  filter = 'all',
}: {
  dealId: number;
  type: string;
  page?: number;
  sort?: DiscussionSort;
  filter?: DiscussionFilter;
}) {
  let requestParams: any = {
    group: type,
    page: page,
    for_nuxt_pdp: 'True',
    sort: 'date',
    order: 'desc',
  };

  switch (sort) {
    case 'latest':
    case 'newest':
      (requestParams['sort'] = 'date'), (requestParams['order'] = 'desc');
      break;

    case 'oldest':
      (requestParams['sort'] = 'date'), (requestParams['order'] = 'asc');
      break;

    case 'helpful':
      requestParams['sort'] = 'helpful';
      break;

    case 'rating:asc':
      (requestParams['sort'] = 'rating'), (requestParams['order'] = 'asc');
      break;

    case 'rating:desc':
      (requestParams['sort'] = 'rating'), (requestParams['order'] = 'desc');
      break;
  }

  switch (filter) {
    case 'unapproved':
      requestParams['moderator_filter'] = 'unapproved';
      break;

    case 'unresolved':
      requestParams['moderator_filter'] = 'unresolved';
      break;
  }

  requestParams = Object.keys(requestParams)
    .map((key: string) => `${key}=${encodeURIComponent(requestParams[key])}`)
    .join('&');

  return `/discussions/api/listcomments/${dealId}/?${requestParams}`;
}

/**
 * Fetch comments from the discussions API.
 */
export async function getComments(url: string) {
  return fetchJson(url).then((data) => {
    return data?.comments || [];
  });
}
